module.exports = __webpack_public_path__ + "img/manage@2x.bf21708c.png";